import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  backfillPaymentMetrics,
  getPaymentBreaches,
  getPaymentMetrics,
  getPaymentTeamMetrics,
} from '../../api/endpoints/payments';
import type { PaymentMetricsRange } from '../../api/types';
const refresh = { refetchInterval: false as const, refetchOnWindowFocus: 'always' as const };
export function usePaymentMetrics(range: PaymentMetricsRange, enabled: boolean) {
  return useQuery({
    queryKey: ['payments', 'metrics', range],
    queryFn: () => getPaymentMetrics(range),
    enabled,
    ...refresh,
  });
}
export function usePaymentTeamMetrics(range: PaymentMetricsRange, enabled: boolean) {
  return useQuery({
    queryKey: ['payments', 'metrics', 'team', range],
    queryFn: () => getPaymentTeamMetrics(range),
    enabled,
    ...refresh,
  });
}
export function usePaymentBreaches(
  range: PaymentMetricsRange,
  mine: boolean,
  page: number,
  enabled: boolean,
) {
  const filters = { ...range, mine, page, size: 50 };
  return useQuery({
    queryKey: ['payments', 'metrics', 'breaches', filters],
    queryFn: () => getPaymentBreaches(filters),
    enabled,
    ...refresh,
  });
}
export function useBackfillPaymentMetrics() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (range: PaymentMetricsRange) => backfillPaymentMetrics(range),
    onSuccess: () => client.invalidateQueries({ queryKey: ['payments', 'metrics'] }),
  });
}
